module.exports = __webpack_public_path__ + "static/images/redeemrule.d86cd2c.png";